import { UsuarioOnline } from './UsuarioOnline.entity';

export class UsuarioUpdate {
    UsuarioOnline: UsuarioOnline;
    cambioPassword: boolean;
    passwordRepetir: string;
    oldPassword: string;
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/usuarioUpdate.entity.ts